//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapMutations } from "vuex";
export default {
  data() {
    return {
      drawer: null,
    };
  },
  methods: {
    ...mapMutations(["setMainMenuDrawer"]),
    toggleMenu: function () {
      this.setMainMenuDrawer(!this.getMainMenuDrawer);
    },
    closeMenu: function () {
      this.setMainMenuDrawer(false);
    },
  },
  computed: {
    ...mapGetters(["getCrfTitle", "getMenuItems", "getMainMenuDrawer"]),
    getMainMenuDrawerLocal: {
      get: function () {
        return this.getMainMenuDrawer;
      },
      set: function (value) {
        this.setMainMenuDrawer(value);
      },
    },
    classToolbarTitleText: function () {
      return {
        "toolbar-title-text-md": this.$vuetify.breakpoint.mdAndUp,
        "toolbar-title-text-sm": this.$vuetify.breakpoint.smAndDown,
      };
    },
    classCrfTitleText: function () {
      return {
        "crf-title-text-md": this.$vuetify.breakpoint.mdAndUp,
        "crf-title-text-sm": this.$vuetify.breakpoint.smAndDown,
      };
    },
  },
};
